import { useCallback, useEffect, useRef, useState } from "react";

import getThemeColors, {
  ThemeColors
} from "../../components/YleAudioPlayer/getThemeColors";
import { THEME } from "../../enums";
import { Theme } from "../../types/common";

export const useThemeColors = (theme: Theme): ThemeColors => {
  const [themeColors, setThemeColors] = useState(getThemeColors(theme));
  const matchMediaRef = useRef(
    window.matchMedia("(prefers-color-scheme: dark)")
  );

  const updateThemeColors = useCallback(() => {
    setThemeColors(getThemeColors(theme));
  }, [theme]);

  useEffect(() => {
    if (theme === THEME.AUTO) {
      matchMediaRef.current.addEventListener("change", updateThemeColors);
      return () => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        matchMediaRef.current.removeEventListener("change", updateThemeColors);
      };
    }
  }, [updateThemeColors, theme]);

  return themeColors;
};
